import cookie from '@snapask/common-components/dist/utils/cookie';

import config from '@dragonfruit/config';
const { COOKIE_DOMAIN } = config;

const COOKIE_KEY_QUESTION_ID = 'QUESTION_ID';

export const saveQuestionId = id => {
  const snapCookie = new cookie(COOKIE_DOMAIN);
  snapCookie.setCookie(COOKIE_KEY_QUESTION_ID, id);
};

export const getQuestionId = () => {
  const snapCookie = new cookie(COOKIE_DOMAIN);
  const questionId = snapCookie.readCookie(COOKIE_KEY_QUESTION_ID);

  if (questionId) {
    return parseInt(questionId, 10);
  }

  return questionId;
};



// WEBPACK FOOTER //
// ./app/utils/temporaryQuestion.js